import { FieldGroup } from './FieldGroup';
import { resolveGroups } from './formLayout';
import { RelatedSections } from './general/RelatedSections';
import { SubTables } from './general/SubTables';
import { UnderTitleFields } from './general/UnderTitleFields';
import type { IRecordFormProps } from './IRecordFormProps';

/**
 * Вкладка «Загальне» повної форми (UIUX forms/form-structure, FORM_LAYOUT §1–3; прототип v4): поля під назвою з визначення (назва,
 * теги, опис), групи визначення на полотні (дві колонки, коли кожна має ≥ 480px), підтаблиці «Подробиці» і «Пов’язані записи». У режимі
 * перегляду поля сірі й недоступні (data-ro прототипу); один компонент для всіх типів записів.
 */
export function RecordForm({ ws, module, rt, record, editor, readOnly, onLinkModule, onOpenLinked }: IRecordFormProps) {
  const groups = resolveGroups(rt);
  return (
    <div className="rec-general" data-ro={readOnly ? '1' : '0'}>
      {record && <UnderTitleFields ws={ws} rt={rt} record={record} editor={editor} readOnly={readOnly ?? true} />}
      {groups.length > 0 && (
        <div className="form-canvas">
          {groups.map((g) => <FieldGroup key={g.id} ws={ws} rt={rt} group={g} record={record} editor={editor} readOnly={readOnly} />)}
        </div>
      )}
      {record && <SubTables ws={ws} module={module} rt={rt} record={record} />}
      {record && <RelatedSections ws={ws} rt={rt} record={record} onLink={(m) => onLinkModule?.(m)} onOpen={(i) => onOpenLinked?.(i)} />}
    </div>
  );
}
